(function () {
    'use strict'
    angular.module('clientDashboardApp.common')
      .controller("ImageUploadModalCtrl", function ImageUploadModalCtrl(
        $scope,
        Upload,
        configService,
        userService,
        imageType,
        accountId,
        preventSave,
        imageUploadEndpoint,
        afterSaveCallback
      ) {
          function updateCurrentStep(step) {
            $scope.currentStep = step;
          }

          resetState(false);

          updateCurrentStep(0);

          function resetState(useInterruptFlag) {
            $scope.updatingRestrictions = false;
            $scope.errorMsg = "";
            $scope.failedUpload = false;
            $scope.failedSave = false;
            $scope.tmpImageUrl = null;
            $scope.savingImage = false;
            $scope.fileUploading = false;
            if (useInterruptFlag) {
              $scope.interruptFlag = true;
            }
          }

          $scope.brandManagerConfig = {
            state: {
              updating: false,
              success: false
            },
            save: false
          }

          $scope.brandRestrictionFields = [];
          $scope.tempRestrictions = {};
          $scope.configSettings = {};
          $scope.preventSave = preventSave;

          userService.currentUser().then(user => {
            $scope.account = {
              id: user.accountId
            }
          })

          $scope.saveConfig = function () {
            $scope.brandManagerConfig.save = true;
          }

          // upload later on form submit or something similar
          $scope.submit = function () {
            if ($scope.form.file.$valid && $scope.file) {
              $scope.upload($scope.file);
            }
          };

          $scope.saveImage = function () {
            $scope.savingImage = true;
            configService.saveImage($scope.tmpImageUrl,imageType,accountId).then(function (resp) {
              $scope.savingImage = false;
              updateCurrentStep(2);
              afterSaveCallback($scope.tmpImageUrl)
            }, function () {
              $scope.savingImage = false;
              $scope.failedSave = true;
            });
          }

          function showFailedError(error) {
            $scope.errorMsg = error.message;
          }

          // upload on file select or drop
          $scope.upload = function (files) {
            if (files && files.length) {
              for (let i = 0; i < files.length; i++) {
                const file = files[i];
                $scope.uploadProgress = 0;
                $scope.fileUploading = file.name;

                Upload.upload({
                  url: imageUploadEndpoint,
                  data: {file: file,imageType:imageType}
                }).progress(function (evt) {
                  $scope.uploadProgress = parseInt(100.0 * evt.loaded / evt.total);
                }).success(function (data, status, headers, config) {
                  if (!$scope.interruptFlag) {
                    $scope.tmpImageUrl = data.replace(/\\|"/g, "");
                    updateCurrentStep(1);
                  }
                  else {
                    updateCurrentStep(0);
                    $scope.interruptFlag = false;
                  }
                }).error(function (data, status, headers, config) {
                  updateCurrentStep(0);
                  $scope.fileUploading = false;
                  $scope.failedUpload = true;
                  showFailedError({message: "Problem uploading file: " + data});
                });

              }
            }
          };
        }
      )
  })()
